export MainContent from './main-content.js';
export MainContentHeader from './main-content-header.js';
export MainContentHeaderButtons from './main-content-header-buttons.js';
export MainContentTabs from './main-content-tabs.js';
export MainContentFilter from './main-content-filter.js';
export MainContentSection from './main-content-section.js';



/** WEBPACK FOOTER **
 ** ./client/pages/layout/main-content/index.js
 **/